import SectionPanel from './SectionPanel';

export default SectionPanel;
